import GameInstaller from './game-installer.component';

export default GameInstaller;
